import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_content_block = _resolveComponent("product-content-block")!

  return (_ctx.brandlineContent)
    ? (_openBlock(), _createBlock(_component_product_content_block, {
        key: 0,
        class: "product-brandline-content",
        "show-carousel": _ctx.showCarousel,
        "show-title": _ctx.showTitle,
        "fallback-image": _ctx.fallbackImage,
        headline: _ctx.brandlineContent.displayName,
        subline: _ctx.brandlineContent.subtitle,
        text: _ctx.brandlineContent.shortDescription,
        "link1-text": _ctx.brandlineContent.linkText,
        "link1-url": _ctx.brandlineContent.linkUrl,
        "link2-text": _ctx.brandlineContent.linkText2,
        "link2-url": _ctx.brandlineContent.linkUrl2,
        images: _ctx.brandlineContent.images,
        videos: _ctx.brandlineContent.videos,
        type: "brandline",
        "read-more-target-class": "product-details__headline--product-brandline-content",
        "use-read-more": _ctx.useReadMore
      }, null, 8 /* PROPS */, ["show-carousel", "show-title", "fallback-image", "headline", "subline", "text", "link1-text", "link1-url", "link2-text", "link2-url", "images", "videos", "use-read-more"]))
    : _createCommentVNode("v-if", true)
}